import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { tagQueries } from '../../../queries';
import { Button } from 'src/shared/components/button';
import { Field } from 'src/shared/components/form/field';
import { FieldLabel } from 'src/shared/components/form/field/label';
import { useElementVisibility } from 'src/shared/hooks/useElementVisibility';
import { useLayout } from 'src/shared/hooks/useLayout';
function tagIsValid(tag) {
    return tag.trim() !== '';
}
export function TagInput() {
    const { t } = useTranslation();
    const { isMobile } = useLayout();
    const form = useFormContext();
    const tags = form.watch('tags');
    const [text, setText] = useState('');
    const suggestionDataListId = useId();
    const tagInputId = useId();
    const { elementRef, isVisible } = useElementVisibility();
    const suggestions = useQuery({
        ...tagQueries.getAll,
        enabled: isVisible
    });
    function handleAdd(tag) {
        if (tagIsValid(tag)) {
            setText('');
            form.setValue('tags', [...tags, tag.trim()], { shouldDirty: true });
        }
    }
    function handleEnterOrCommaKeyPress(event) {
        if (event.key === 'Enter' || event.key === ',') {
            event.stopPropagation();
            event.preventDefault();
            handleAdd(text);
        }
    }
    function handleTextChange(event) {
        setText(event.target.value);
    }
    return (_jsxs("div", { className: "mb-0 flex flex-col gap-2", ref: elementRef, children: [_jsx(FieldLabel, { className: "mb-0", htmlFor: tagInputId, children: t('content.form.search_tags.label') }), _jsxs("div", { className: "mb-4 flex w-full flex-col items-start gap-2 md:flex-row", children: [_jsxs(Field, { className: "mb-0 w-full grow", supportMessage: isMobile ? undefined : t('content.form.search_tags.help'), style: { '--hc-form-field-margin-bottom': 0 }, children: [_jsx("input", { id: tagInputId, value: text, onKeyDownCapture: handleEnterOrCommaKeyPress, onChange: handleTextChange, list: suggestionDataListId, placeholder: t('content.form.search_tags.placeholder') }), _jsx("datalist", { id: suggestionDataListId, children: suggestions.data?.map((suggestion) => _jsx("option", { value: suggestion }, suggestion)) })] }), _jsx(Button, { variation: "primary", onClick: () => handleAdd(text), disabled: !tagIsValid(text), className: "w-full md:w-auto", children: t('general.add') })] })] }));
}
